module.exports = __webpack_public_path__ + "media/video.da1a2f76.mp4";